module.exports = __webpack_public_path__ + "img/Headingold.137ffa81.svg";